import React, { useContext } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import "../../../css/login/login.css";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../button/ButtonWhite";
import ButtonTransparent from "../../button/ButtonTransparent";
import InputLogin from "../../inputs/InputLogin";
import { useNavigate } from 'react-router-dom';

const Login = ({
  loading,
  errorUsername,
  email,
  setEmail,
  errorPassword,
  password,
  setPassword,
  error,
  LoginRequest,
  setLayout,
  reguestPassword
}) => {
  const navigate = useNavigate();
  const { language } = useContext(UtilContext);

  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-3/4 flex justify-evenly flex-col"
    >
      <div className="flex flex-col">
        <p className="title">{GLOBAL_LANGUAGE[language].login.title}</p>
        <p className="text-base font-medium leading-5 traking-[-0.32px] text-[#B7B7B9] mb-1">
          {GLOBAL_LANGUAGE[language].login.label_email}
        </p>
        <form>
          <InputLogin
            error={errorUsername}
            value={email}
            onChange={(e) => setEmail(e)}
            label={GLOBAL_LANGUAGE[language].login.label_email}
            placeholder={GLOBAL_LANGUAGE[language].login.placeholder_email}
          />
          <div className="flex flex-row justify-between mb-1 mt-4">
            <p className="text-base text-[#B7B7B9] font-medium leading-5 traking-[-0.32px]">
              {GLOBAL_LANGUAGE[language].login.label_password}
            </p>
            <p className="text-base font-medium leading-5 traking-[-0.32px] underline">
              <a className="cursor-pointer" onClick={reguestPassword}>
                {GLOBAL_LANGUAGE[language].login.request_password}
              </a>
            </p>
          </div>

          <InputLogin
            error={errorPassword}
            value={password}
            LoginRequest={LoginRequest}
            onChange={(e) => setPassword(e)}
            password={true}
            label={GLOBAL_LANGUAGE[language].login.label_password}
            placeholder={GLOBAL_LANGUAGE[language].login.placeholder_password}
          />
        </form>
        <p style={{ color: ColorsMain.errorBorder, marginTop: 8 }}>{error}</p>
        <div className="flex flex-col-reverse md:flex-row w-full justify-between gap-4 mt-4">
          <ButtonTransparent
            onClick={() => navigate('/registro')}
            label={GLOBAL_LANGUAGE[language].login.buton_register}
            className="w-full md:w-fit"
          />
          <ButtonWhite
            onClick={() => LoginRequest()}
            label={GLOBAL_LANGUAGE[language].login.label_button_login}
            loading={loading}
            className="w-full md:w-fit"
          />
        </div>
      </div>
      <div className="flex flex-row justify-between mt-8 md:mt-20">
        <p className="text-sm cursor-pointer underline" >
          <a href="https://www.colurs.io/terminos/" target="_blank">
            {GLOBAL_LANGUAGE[language].login.tyc}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
